export default __webpack_public_path__ + "assets/29b62ebbf594b3a836a77b3220b7f790.jpeg";